import { getMessages } from '../../../../../../store/constants';

export const BOARD_SECTION_GANTT = getMessages().getText('showOnGantt.title');
export const BOARD_SECTION_GANTT_BUTTON = getMessages().getText('showOnGantt.button');
